import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Stack } from '@mui/material';
export function Connecting() {
    return (_jsx(Stack, Object.assign({ flexGrow: "1", justifyContent: "center", alignItems: "center" }, { children: _jsx(CircularProgress, {}) })));
}
